import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const authRoutes = {
  login: "/login",
  logout: "/logout",
  forgotPassword: "/forgotPassword",
  resetPassword: "/resetPassword",
};
export function useAuthRoutes() {
  const navigate = useNavigate();

  const goToLoginPage = useCallback(() => {
    navigate({
      pathname: authRoutes.login,
    });
  }, [navigate]);

  return { goToLoginPage, authRoutes };
}
